
import {
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  SelectChangeEvent,
  Stack,
} from "@mui/material";
import { useFormik } from "formik";
import React from "react";
import {
  ControlledCustomSelect,
  CustomFormLabel,
  CustomSelect,
  CustomTextField,
} from "../../../../../../../components/formsComponents";
import { renderDropdownValue } from "../../../../../../../helpers";
import {
  cancelType,
  policyStatus,
  transactionTypes,
  typeOfPolicy,
  cancellationReason,
  application_language,
  STANDARD_APP_TIME_FORMAT,
} from "../../../../../../../constants/constants";
import { ILocationResponsePayload } from "../../../../../../../components/LocationAutoComplete/LocationAutoComplete";
import {
  CustomDatePicker,
  CustomTimePicker,
} from "../../../../../../../components/formsComponents/CustomDatePicker";
import {
  useCustomerFullInfo,
  useCustomerPolicyDetails,
  useCustomerPropspect,
  useDispatchWrapper,
  useFetchPolicies,
} from "../../../../../../../hooks";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../../redux/initialStoreState";
import moment from "moment";
import { LabelCard } from "../../../../../../../components/LabelCard/LabelCard";
import {
  fetchHabitationalAdditionalInsuredListAsync,
  upsertHabitationalAdditionalInsuredAsync,
} from "../../../../../../../redux/habitationalPolicy/habitationalBasicDetails/habitationalBasicDetailsActions";
import { IHabitationalAdditionalInsured } from "../../../../../../../redux/habitationalPolicy/habitationalBasicDetails/habitationalBasicDetails.types";
import { saveCustomerPolicyDetailsAsync } from "../../../../../../../redux/customerPolicyDetails/customerPolicyDetailsActions";
import { ICustomerPolicyDetails } from "../../../../../../../redux/customerPolicyDetails/customerPolicyDetails.types";
import {
  MASTER_DROP_DOWN_CODES,
  MODULE_IDS,
  POLICIES,
  ROLES,
} from "../../../../../../../constants/enums";
import { MasterDropdown } from "../../../../../../MasterDropdowns/MasterDropdown";
import { useNavigate } from "react-router-dom";
import { RoleBasedCustomButton } from "../../../../../../../security/RoleBasedComponents/RoleBasedCustomButton/RoleBasedCustomButton";
import { BinderNumber } from "../../../../../../../components/BinderNumber/BinderNumber";
import { useTabsUncontrolledContext } from "../../../../../../../contexts/TabsContextProvider/TabsContextUncontrolledProvider";
import { AddressSearchAutoComplete } from "../../../../../../../components/AddressAutoComplete/AddressSearchAutoComplete";


import { FieldSet } from "../../../../../../../components/FieldSet/FieldSet";
import { CustomerContactTable } from "./CustomerContactTable";
import produce from "immer";
import { HabitationalPolicyAdmin } from "../PolicyAdmin/PolicyAdmin";
import { showMessage } from "../../../../../../../redux/messages/messagesActions";
import { isEqual } from "lodash";
import { useSearchParams } from "react-router-dom";
import { useRoles } from "../../../../../../../security/RolesProvider/RolesProvider";

export const HabitationalCustomerInfo: React.FC<{
  customerId: number;
  customerPolicyId?: number;
}> = (props) => {
  const { customerId, customerPolicyId } = props;
  const isUpdate = customerPolicyId ? true : false;
  const customerFullDetails = useCustomerFullInfo();
  const customerProspect = useCustomerPropspect();
  const { details } = useCustomerPolicyDetails(
    customerPolicyId ? Number(customerPolicyId) : undefined
  );
  const [buttonClicked, setButtonClicked] = React.useState<string | null>(null);
  const { changeStep } = useTabsUncontrolledContext();
  const dispatch = useDispatchWrapper();
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { roleName } = useRoles();
  const { list, loading: listloading } = useSelector(
    (storeState: IStoreState) =>
      storeState.habitational.basicDetails.additional_insured
  );
  // additional_insured is a separate policy section and is intentionally kept
  // out of the merged ICustomerPolicyDetails contract. It is held in local
  // state here (seeded from the redux additional_insured list) and persisted
  // through its own dedicated action.
  const [additionalInsuredList, setAdditionalInsuredList] = React.useState<
    IHabitationalAdditionalInsured[]
  >([]);
  const { getPolicySubtypes } = useFetchPolicies();
  const customerPolicyIdRef = React.useRef(customerPolicyId);
  const {
    values,
    handleChange,
    handleSubmit,
    setValues,
    setFieldValue,
    errors,
    submitForm,
    ...restFormik
  } = useFormik<ICustomerPolicyDetails>({
    initialValues: {
      ...details.data,
      effective_time:
        details.data.effective_time ||
        moment()
          .startOf("day")
          .add(1, "minute")
          .format(STANDARD_APP_TIME_FORMAT),
    },
    enableReinitialize: true,
    validate: (values) => {
      const errors: any = {};
      if (!values.customer_name) {
        errors.customer_name = "*Customer name is required!";
      } else if (!values.form_of_business) {
        errors.form_of_business = "*Form of Business is required";
      } else if (!values.transaction_type) {
        errors.transaction_type = "*Transaction type is required!";
      } else if (!values.residential_or_business) {
        errors.residential_or_business = "*Address type is required!";
      } else if (!values.line_of_business) {
        errors.line_of_business = "*Line of Business is required";
      } else if (Number(values.policy_sub_type) === 0) {
        errors.policy_sub_type = "*Line of Business is required";
      } else if (!values.producer_one) {
        errors.producer_one = "Producer 1 is requried";
      }
      // if (!values.segment || values.segment.length === 0) {
      //   errors.segment = "*Segment is required!";
      // }

      if (values.current_policy_status === "Active") {
        if (!values.binder_number) {
          errors.binder_number = "*Binder number is required!";
        }
      }

      return errors;
    },
    onSubmit: async (values) => {
      return new Promise((resolve, reject) => {
        setLoading(true);
        dispatch(
          saveCustomerPolicyDetailsAsync(
            { ...values, customer_id: customerId },
            details.data,
            isUpdate,
            (isSuccess, policyId, error) => {
              if (error) {
                reject(error);
              }
              if (isSuccess && policyId) {
                customerPolicyIdRef.current = policyId;
                resolve(policyId);
              }
              setLoading(false);
            }
          )
        );
      });
    },
  });

  // A single merged Formik now drives the customer info, policy admin, and
  // premium sections. The PolicyAdmin/Premium subcomponent binds to this same
  // Formik instance for both its `policyAdmin` and `policyPremimum` props,
  // since all fields now live on one canonical merged object.
  const mergedFormik = {
    values,
    handleChange,
    setFieldValue,
    setValues,
    errors,
    ...restFormik,
  };

  const handleFinalSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      let saveResult: any = true;

      if (isUpdate) {
        // Single change-detection gate: only save when the current form values
        // differ from the persisted merged Customer_Policy_Details.
        const detailsChanged = !isEqual(
          { ...values, customer_id: customerId },
          { ...details.data, customer_id: customerId }
        );

        if (detailsChanged) {
          saveResult = await submitForm();
        }
      } else {
        saveResult = await submitForm();
      }

      if (saveResult) {
        navigate(
          `/habitational-policy/${props.customerId}/basic-details/${customerPolicyIdRef.current}`
        );
        if (buttonClicked === "saveAndNext") {
          changeStep(1);
        }
        dispatch(
          showMessage({
            type: "success",
            message: "Customer policy information saved successfully!",
            displayAs: "snackbar",
          })
        );
        // Reload the page after a successful save so the latest persisted
        // data is reflected across all tabs/sections.
        window.location.reload();
      }
    } catch (error: any) {
      dispatch(
        showMessage({
          type: "error",
          message: error.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      setLoading(false); // Stop loading indicator
    }
  };

  const handleBinderSave = (
    binderNumber: string | null,
    onCallBack: (isSuccess: boolean) => void
  ) => {
    dispatch(
      saveCustomerPolicyDetailsAsync(
        { ...values, customer_id: customerId, binder_number: binderNumber },
        details.data,
        isUpdate,
        (isSuccess) => {
          onCallBack(isSuccess);
        }
      )
    );
  };

  const handleCheckBox =
    (key: keyof ICustomerPolicyDetails) =>
      (e: React.SyntheticEvent<Element>, checked: boolean) => {
        setFieldValue(key, checked);
      };

  const handleAddress = (data: ILocationResponsePayload) => {
    setValues((prevValues: any) => ({
      ...prevValues,
      address: data.address,
      city: data.city,
      country: data.country,
      province_or_state: data.state,
      postal_code: data.postalCode,
    }));
  };

  const handlePolicyStatusChange = (event: SelectChangeEvent<unknown>) => {
    const { value } = event.target;

    // Safely cast value to string
    const selectedValue = value as string; // Cast `unknown` to `string`

    const newValues = produce(values, (draftValues) => {
      draftValues.current_policy_status = selectedValue;
      draftValues.binder_number =
        selectedValue === "Prospect" ? null : values.binder_number;
      draftValues.policy_number =
        selectedValue === "Prospect" ? null : values.policy_number;
      if (selectedValue === "Voided") {
        draftValues.cancellation_reason = "NT: Not Taken";
        draftValues.date_cancelled = values.effective_date;
        draftValues.policy_status = "Voided";
      }
    });

    setValues(newValues);
  };

  const handleFormOfBusiness = async (event: SelectChangeEvent<unknown>) => {
    const formOfBusiness = event.target.value as string;

    if (customerPolicyId) {
      dispatch(fetchHabitationalAdditionalInsuredListAsync(customerPolicyId));
    }
    setValues({
      ...values,
      form_of_business: formOfBusiness,
    });
  };

  // Load the persisted additional-insured list for an existing policy so the
  // contact table is populated on open (Individual form-of-business only).
  React.useEffect(() => {
    if (customerPolicyId) {
      dispatch(fetchHabitationalAdditionalInsuredListAsync(customerPolicyId));
    }
  }, [customerPolicyId]);

  // Keep the local editable list in sync with the redux additional-insured list.
  React.useEffect(() => {
    setAdditionalInsuredList(list || []);
  }, [list]);

  // Persist a create/edit/delete of an additional-insured contact through its
  // own dedicated action, then refresh the list from the server so the table
  // reflects the canonical persisted state.
  const handleAdditionalInsuredChange = (
    nextList: IHabitationalAdditionalInsured[]
  ) => {
    setAdditionalInsuredList(nextList);

    const changed = nextList.find((item) => {
      const previous = (list || []).find(
        (x) => x.incremental_number === item.incremental_number
      );
      return !isEqual(previous, item);
    });

    if (!changed) {
      return;
    }

    dispatch(
      upsertHabitationalAdditionalInsuredAsync(
        {
          ...changed,
          customer_id: customerId as number,
          customer_policy_id: customerPolicyId as number,
        },
        (isSuccess) => {
          if (isSuccess && customerPolicyId) {
            dispatch(
              fetchHabitationalAdditionalInsuredListAsync(customerPolicyId)
            );
          }
        }
      )
    );
  };

  React.useEffect(() => {
    if (!customerPolicyId && customerFullDetails) {
      // New Policy Case — force Prospect
      const urlTransactionType = searchParams.get("transaction_type");
      setValues((prevValues: any) => ({
        ...prevValues,
        customer_code: customerProspect.data.customer_code,
        customer_name: customerProspect.data.customer_name,
        address: prevValues.address || customerProspect.data.mailing_address,
        province_or_state:
          prevValues.province_or_state ||
          customerProspect.data.province_or_state,
        city: prevValues.city || customerProspect.data.city,
        postal_code:
          prevValues.postal_code || customerProspect.data.postal_code,
        country: prevValues.country || customerProspect.data.country,
        unit_or_suite:
          prevValues.unit_or_suite || customerProspect.data.unit_or_suite,
        language: customerProspect.data.language,
        line_of_business: POLICIES.HABITATIONAL_POLICY,
        form_of_business: customerProspect.data.form_of_business,
        effective_time: moment()
          .startOf("day")
          .add(1, "minute")
          .format(STANDARD_APP_TIME_FORMAT),
        current_policy_status: "Prospect",
        // Seed the merged policy-admin defaults from the customer prospect so
        // branch/producer/csr/marketer auto-populate for a new policy. Seeding
        // lives on the single owning Formik (CustomerInfo) to avoid a race with
        // a second seeding effect in the PolicyAdmin subcomponent.
        csr_code: prevValues.csr_code || customerProspect.data.csr_code,
        csr: prevValues.csr || customerProspect.data.csr,
        marketer: prevValues.marketer || customerProspect.data.marketer,
        marketer_code:
          prevValues.marketer_code || customerProspect.data.marketer_code,
        producer_one: prevValues.producer_one || customerProspect.data.producer,
        producer_one_code:
          prevValues.producer_one_code || customerProspect.data.producer_code,
        branch_code: prevValues.branch_code || customerProspect.data.branch_code,
        default_tax_region:
          prevValues.default_tax_region || customerFullDetails.tax_zone || "",
        ...(urlTransactionType ? { transaction_type: urlTransactionType } : {}),
      }));
    } else if (customerPolicyId) {
      setValues((prevValues: any) => ({
        ...prevValues,
        ...details.data,
        current_policy_status:
          details.data?.current_policy_status || "Prospect",
      }));
    }
  }, [details.data, customerProspect.data, customerPolicyId]);

  return (
    <form onSubmit={handleFinalSubmit}>
      <Grid container spacing={1}>
        <Grid item xs={12} lg={2.4}>
          <CustomFormLabel>Customer Name</CustomFormLabel>
          <CustomTextField
            id="customer_name"
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            value={values.customer_name}
            onChange={handleChange}
            error={errors.customer_name ? true : false}
            helperText={errors.customer_name as string}
          />
        </Grid>

        <Grid item xs={12} lg={2.4}>
          <CustomFormLabel>Customer Code</CustomFormLabel>
          <CustomTextField
            name="customer_code"
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            disabled
            value={values.customer_code}
          />
        </Grid>

        <Grid item xs={12} lg={2.4}>
          <CustomFormLabel>Transaction Type</CustomFormLabel>
          <ControlledCustomSelect
            variant="outlined"
            size="small"
            type="string"
            name="transaction_type"
            fullWidth
            disabled={roleName !== ROLES.ADMIN}
            value={values.transaction_type}
            onChange={handleChange}
            displayEmpty
            placeholder="Select one"
            error={errors.transaction_type ? true : false}
            helperText={errors.transaction_type as string}
            options={transactionTypes.map((transactionType) => {
              return { label: transactionType, value: transactionType };
            })}
          ></ControlledCustomSelect>
        </Grid>

        <Grid item xs={12} lg={2.4}>
          <CustomFormLabel>Form of Business</CustomFormLabel>
          <MasterDropdown
            fullWidth
            dropdownCode={MASTER_DROP_DOWN_CODES.FORM_OF_BUSINESS}
            value={values.form_of_business}
            onChange={handleFormOfBusiness}
            placeholder="Select one"
            errorMessage={errors.form_of_business as string}
          />
        </Grid>

        <Grid item xs={12} lg={2.4}>
          <CustomFormLabel>Language</CustomFormLabel>
          <ControlledCustomSelect
            fullWidth
            value={values.language}
            name="language"
            onChange={handleChange}
            placeholder="Select One"
            displayEmpty
            options={application_language}
          ></ControlledCustomSelect>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12} lg={1.4}>
          <CustomFormLabel>Address Type</CustomFormLabel>
          <ControlledCustomSelect
            variant="outlined"
            size="small"
            type="string"
            name="residential_or_business"
            fullWidth
            value={values.residential_or_business}
            onChange={handleChange}
            displayEmpty
            placeholder="Select one"
            error={errors.residential_or_business ? true : false}
            helperText={errors.residential_or_business as string}
            options={["R", "B"].map((transactionType) => {
              return { label: transactionType, value: transactionType };
            })}
          ></ControlledCustomSelect>
        </Grid>
        <Grid item xs={12} lg={3}>
          <AddressSearchAutoComplete
            address={values.address}
            onAddressChange={handleAddress}
          />
        </Grid>
        <Grid item xs={12} lg={1.8}>
          <CustomFormLabel>Unit/Suite</CustomFormLabel>
          <CustomTextField
            name="unit_or_suite"
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            value={values.unit_or_suite}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} lg={1.8}>
          <CustomFormLabel>City</CustomFormLabel>
          <CustomTextField
            id="city"
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            value={values.city}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} lg={1.2}>
          <CustomFormLabel>State/Province</CustomFormLabel>
          <CustomTextField
            id="province_or_state"
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            value={values.province_or_state}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} lg={1.2}>
          <CustomFormLabel>Postal Code</CustomFormLabel>
          <CustomTextField
            id="postal_code"
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            value={values.postal_code}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} lg={1.6}>
          <CustomFormLabel>Country</CustomFormLabel>
          <CustomTextField
            id="country"
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            value={values.country}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
      <Grid container spacing={1} mt={2}>
        <Grid item xs={12} lg={12}>
          <CustomerContactTable
            additionalInsuredList={additionalInsuredList}
            onChange={handleAdditionalInsuredChange}
            customerId={customerId}
            customerPolicyId={customerPolicyId}
          />
        </Grid>
      </Grid>

      <LabelCard heading="Policy Information" />

      <Grid container spacing={1}>
        <Grid item xs={12} md={1.5}>
          <CustomFormLabel>Quote Number</CustomFormLabel>
          <CustomTextField
            name="quote_number"
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            value={values.quote_number}
            onChange={handleChange}
            disabled={!customerPolicyId}
          />
        </Grid>

        {values.current_policy_status !== "Prospect" && (
          <>
            <BinderNumber
              value={values.binder_number}
              policyId={customerPolicyId}
              onSave={handleBinderSave}
              girdSize={2.5}
              error={errors.binder_number ? true : false}
              helperText={errors.binder_number as string}
            />

            <Grid item xs={12} lg={2.5}>
              <CustomFormLabel>Policy Number</CustomFormLabel>
              <CustomTextField
                name="policy_number"
                variant="outlined"
                size="small"
                type="text"
                fullWidth
                value={values.policy_number}
                onChange={(e) => {
                  const formatted = e.target.value
                    .replace(/\s+/g, "")
                    .toUpperCase();
                  setFieldValue("policy_number", formatted);
                }}
                disabled={!customerPolicyId}
              // required={values.current_policy_status === "Active"}
              />
            </Grid>
          </>
        )}

        <Grid item xs={12} md={2}>
          <CustomFormLabel>Effective Date</CustomFormLabel>
          <CustomDatePicker
            fullWidth
            value={values.effective_date}
            onChange={(newValue) => {
              const originalDate = moment(newValue);
              const expiryDate = originalDate
                .add(1, "year")
                .format("YYYY-MM-DD");

              setValues({
                ...values,
                effective_date: newValue,
                expiry_date: expiryDate,
              });
            }}
          />
        </Grid>

        <Grid item xs={12} md={customerPolicyId ? 1.7 : 1.8}>
          <CustomFormLabel>Effective Time</CustomFormLabel>
          <CustomTimePicker
            fullWidth
            value={values.effective_time}
            onChange={(newValue) => {
              setFieldValue("effective_time", newValue);
            }}
          />
        </Grid>

        <Grid item xs={12} md={customerPolicyId ? 1.7 : 1.8}>
          <CustomFormLabel>Expiry Date</CustomFormLabel>
          <CustomDatePicker
            fullWidth
            value={values.expiry_date || ""}
            onChange={(newValue) => {
              setFieldValue("expiry_date", newValue);
            }}
          />
        </Grid>



        <Grid item xs={12} lg={2.4}>
          <CustomFormLabel>Policy Type</CustomFormLabel>
          <FieldSet disabled>
            <CustomTextField fullWidth value={values.line_of_business} />
          </FieldSet>
        </Grid>
        {/* <Grid item xs={12} lg={2.4}>
          <CustomFormLabel>Segment</CustomFormLabel>
          <ControlledCustomSelect
            fullWidth
            name="segment"
            value={values.segment || []}
            onChange={handleChange}
            placeholder="Select one"
            displayEmpty
            multiple
            options={automobileSegment.map((template) => {
              return { label: template, value: template };
            })}
            error={errors.segment ? true : false}
            helperText={errors.segment as string}
          ></ControlledCustomSelect>
        </Grid> */}

        <Grid item xs={12} lg={2.4}>
          <CustomFormLabel>Line of Business</CustomFormLabel>
          <ControlledCustomSelect
            variant="outlined"
            size="small"
            type="string"
            name="policy_sub_type"
            fullWidth
            value={values.policy_sub_type}
            onChange={handleChange}
            displayEmpty
            placeholder="Select One"
            helperText={errors.policy_sub_type as string}
            options={getPolicySubtypes(values.line_of_business || "").map(
              (item) => {
                return { label: item.name, value: item.name };
              }
            )}
            error={errors.policy_sub_type ? true : false}
          ></ControlledCustomSelect>
        </Grid>

        <Grid item xs={12} lg={2.4}>
          <CustomFormLabel>Program</CustomFormLabel>
          <ControlledCustomSelect
            fullWidth
            value={values.program}
            name="program"
            onChange={handleChange}
            placeholder="Select one"
            displayEmpty
            options={["Option 1", "Option 2"].map((template) => {
              return { label: template, value: template };
            })}
          ></ControlledCustomSelect>
        </Grid>

        <Grid item xs={12} lg={2.4}>
          <CustomFormLabel>Type of Policy</CustomFormLabel>
          <CustomSelect
            variant="outlined"
            size="small"
            type="string"
            name="type_of_policy"
            fullWidth
            value={values.type_of_policy}
            onChange={handleChange}
            displayEmpty
            renderValue={renderDropdownValue(`Select one`)}
          >
            {typeOfPolicy.map((policyType) => {
              return <MenuItem value={policyType}>{policyType}</MenuItem>;
            })}
          </CustomSelect>
        </Grid>
        <Grid item xs={12} lg={2.4}>
          <CustomFormLabel>Policy Status</CustomFormLabel>
          <ControlledCustomSelect
            variant="outlined"
            size="small"
            type="string"
            name="current_policy_status"
            fullWidth
            value={values.current_policy_status}
            onChange={handlePolicyStatusChange}
            displayEmpty
            placeholder="Select one"
            options={[
              "Active",
              "Cancelled",
              "Lapsed",
              "Prospect",
              "Voided",
            ].map((status) => {
              return { label: status, value: status };
            })}
          ></ControlledCustomSelect>
        </Grid>
        <Grid item xs={12} lg={2.4}>
          <CustomFormLabel>Policy Transaction</CustomFormLabel>
          <CustomSelect
            variant="outlined"
            size="small"
            type="string"
            fullWidth
            name="policy_status"
            value={values.policy_status}
            onChange={handleChange}
            displayEmpty
            renderValue={renderDropdownValue(`Select one`)}
          >
            {policyStatus.map((status) => {
              return <MenuItem value={status}>{status}</MenuItem>;
            })}
          </CustomSelect>
        </Grid>

        {["Cancelled", "Voided"].includes(
          values.current_policy_status as string
        ) && (
            <>
              <Grid item xs={12} lg={2.4}>
                <CustomFormLabel>Cancel Reason</CustomFormLabel>
                <CustomSelect
                  variant="outlined"
                  size="small"
                  type="string"
                  name="cancellation_reason"
                  fullWidth
                  value={values.cancellation_reason}
                  onChange={handleChange}
                  displayEmpty
                  renderValue={renderDropdownValue(`Select one`)}
                >
                  {cancellationReason.map((reason) => {
                    return <MenuItem value={reason}>{reason}</MenuItem>;
                  })}
                </CustomSelect>
              </Grid>

              <Grid item xs={12} lg={2.4}>
                <CustomFormLabel>Date of Cancel</CustomFormLabel>
                <CustomDatePicker
                  fullWidth
                  value={values.date_cancelled || ""}
                  onChange={(newValue) => {
                    setFieldValue("date_cancelled", newValue);
                  }}
                />
              </Grid>

              <Grid item xs={12} lg={2.4}>
                <CustomFormLabel>Cancel Type</CustomFormLabel>
                <CustomSelect
                  variant="outlined"
                  size="small"
                  type="string"
                  fullWidth
                  name="cancellation_type"
                  value={values.cancellation_type}
                  onChange={handleChange}
                  displayEmpty
                  renderValue={renderDropdownValue(`Select one`)}
                >
                  {cancelType.map((status) => {
                    return <MenuItem value={status}>{status}</MenuItem>;
                  })}
                </CustomSelect>
              </Grid>
            </>
          )}

        <Grid item xs={12} lg={2.4}>
          <CustomFormLabel>Remarketed</CustomFormLabel>
          <ControlledCustomSelect
            fullWidth
            value={values.remarketed}
            name="remarketed"
            onChange={handleChange}
            placeholder="Select One"
            displayEmpty
            options={[
              { label: "Yes", value: "Y" },
              { label: "No", value: "N" },
            ]}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <HabitationalPolicyAdmin
            customerpolicyId={customerPolicyId}
            policyAdmin={mergedFormik}
            policyPremimum={mergedFormik}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <LabelCard heading="Preferences" />
        </Grid>

        <Grid container spacing={1}>
          <Grid item xs={12} lg={4}>
            <FormControlLabel
              labelPlacement="end"
              onChange={handleCheckBox(
                "send_invoices_renewal_receivable_via_email"
              )}
              control={
                <Checkbox
                  checked={
                    values.send_invoices_renewal_receivable_via_email ||
                    false
                  }
                />
              }
              label="Send Invoices , Renewal , Receivable By Email"
              sx={{ m: 0, fontSize: 15 }}
            />
          </Grid>

          <Grid item xs={12} lg={4}>
            <FormControlLabel
              labelPlacement="end"
              onChange={handleCheckBox("send_statements_via_email")}
              control={
                <Checkbox
                  name="send_statements_via_email"
                  checked={values.send_statements_via_email || false}
                />
              }
              label="Send Statement By Email"
              sx={{ m: 0, fontSize: 15 }}
            />
          </Grid>

          <Grid item xs={12} lg={4}>
            <FormControlLabel
              labelPlacement="end"
              onChange={handleCheckBox("send_edocs_via_email")}
              control={
                <Checkbox
                  name="send_edocs_via_email"
                  checked={values.send_edocs_via_email || false}
                />
              }
              label="Send Docs By Email"
              sx={{ m: 0, fontSize: 15 }}
            />
          </Grid>
        </Grid>
      </Grid>
      <Stack direction={"row"} spacing={2} sx={{ mt: 2 }}>
        <RoleBasedCustomButton
          type="submit"
          moduleKey={MODULE_IDS.HABITATIONAL}
          disabled={loading}
          variant="contained"
          onClick={() => setButtonClicked("save")}
        >
          Save
        </RoleBasedCustomButton>
        {/* <RoleBasedCustomButton
          type="submit"
          moduleKey={MODULE_IDS.HABITATIONAL}
          disabled={loading}
          variant="contained"
          onClick={() => setButtonClicked("saveAndNext")}
        >
          Save & Next
        </RoleBasedCustomButton> */}
      </Stack>
    </form>
  );
};
